import React from 'react'

function QuestionBlackIcon({ width, height, className }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={className} viewBox="0 0 14.699 14.699">
            <path id="Vector_-_2025-02-11T004123.305" data-name="Vector - 2025-02-11T004123.305" d="M7.35,14.7A7.35,7.35,0,1,1,14.7,7.35,7.349,7.349,0,0,1,7.35,14.7Zm0-1.47a5.88,5.88,0,1,0-4.158-1.722A5.88,5.88,0,0,0,7.35,13.229ZM6.615,9.554h1.47v1.47H6.615Zm1.47-1.209V8.82H6.615v-1.1a.735.735,0,0,1,.735-.735A1.1,1.1,0,1,0,6.268,5.664L4.826,5.375A2.573,2.573,0,1,1,8.085,8.345Z" fill="currentcolor" />
        </svg>
    )
}

export default QuestionBlackIcon